import { createAction, props } from "@ngrx/store";
import { FeatureFlagModel } from "../../models/feature-flag.model";

export const LOAD_FEATURE_FLAG_TELEADVICE = 'Load Feature Flag TeleAdvice';
export const SET_FEATURE_FLAG_TELEADVICE = 'Set Feature Flag TeleAdvice';
export const GET_FEATURE_FLAG_TELEADVICE_ERROR = 'Get Feature Flag TeleAdvice Error';
export const RESET_FEATURE_FLAG_TELEADVICE = 'Reset Feature Flag TeleAdvice';

export const LOAD_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC = 'Load Feature Flag Hills Post Adoption DTC';
export const SET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC = 'Set Feature Flag Hills Post Adoption DTC';
export const GET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC_ERROR = 'Get Feature Flag Hills Post Adoption DTC Error';
export const RESET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC = 'Reset Feature Flag Hills Post Adoption DTC';

export const LOAD_FEATURE_FLAG_INSURANCE = 'Load Feature Flag Insurance';
export const SET_FEATURE_FLAG_INSURANCE = 'Set Feature Flag Insurance';
export const GET_FEATURE_FLAG_INSURANCE_ERROR = 'Get Feature Flag Insurance Error';
export const RESET_FEATURE_FLAG_INSURANCE = 'Reset Feature Flag Insurance';

export const resetFeatureFlagTeleAdvice = createAction(RESET_FEATURE_FLAG_TELEADVICE);
export const loadFeatureFlagTeleAdvice = createAction(LOAD_FEATURE_FLAG_TELEADVICE);
export const setFeatureFlagTeleAdvice =
  createAction(SET_FEATURE_FLAG_TELEADVICE, props<{ featureFlag: FeatureFlagModel }>());
export const getFeatureFlagTeleAdviceError =
  createAction(GET_FEATURE_FLAG_TELEADVICE_ERROR, props<{ errorCode: string, errorMessage: string }>());

export const resetFeatureFlagHillsPostAdoptionDTC = createAction(RESET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC);
export const loadFeatureFlagHillsPostAdoptionDTC = createAction(LOAD_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC);
export const setFeatureFlagHillsPostAdoptionDTC =
  createAction(SET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC, props<{ featureFlag: FeatureFlagModel }>());
export const getFeatureFlagHillsPostAdoptionDTCError =
  createAction(GET_FEATURE_FLAG_HILLS_POST_ADOPTION_DTC_ERROR, props<{ errorCode: string, errorMessage: string }>());

  export const resetFeatureFlagInsurance = createAction(RESET_FEATURE_FLAG_INSURANCE);
export const loadFeatureFlagInsurance = createAction(LOAD_FEATURE_FLAG_INSURANCE);
export const setFeatureFlagInsurance =
  createAction(SET_FEATURE_FLAG_INSURANCE, props<{ featureFlag: FeatureFlagModel }>());
export const getFeatureFlagInsuranceError =
  createAction(GET_FEATURE_FLAG_INSURANCE_ERROR, props<{ errorCode: string; errorMessage: string }>());
